import browser from './browser';
import devices from './devices';
import ellipsis from './ellipsis';
import increaseSpecificity from './increaseSpecificity';
import responsive from './responsive';
import { hideScrollbar, scrollbar } from './scrollbar';
import setInterparagraph from './setInterparagraph';

export const mixins = {
  responsive,
  browser,
  increaseSpecificity,
  ellipsis,
  scrollbar,
  hideScrollbar,
  devices,
  setInterparagraph,
};
